import { ContentSettingDashboard, Techline } from '@packages/models/api';
import { HttpClient } from '@packages/core/http';

export class ContentSettingsService {
    constructor(private http: HttpClient) {}

    async fetchDashboard(): Promise<ContentSettingDashboard> {
        const response = await this.http.orchestrateRequest<ContentSettingDashboard>({
            method: 'GET',
            url: '/techline/dashboard',
        });
        return response.success ? response.data : Promise.reject(response.data);
    }

    async createDashboard(payload: Techline) {
        const response = await this.http.orchestrateRequest({
            method: 'POST',
            url: '/techline/dashboard',
            body: payload,
        });
        return response.success ? response.data : Promise.reject(response.data);
    }

    async updateDashboard(id: string, payload: Partial<Techline>): Promise<ContentSettingDashboard> {
        const response = await this.http.orchestrateRequest<ContentSettingDashboard>({
            method: 'PUT',
            url: `/techline/dashboard/${id}`,
            body: payload,
        });
        return response.success ? response.data : Promise.reject(response.data);
    }

    async deleteDashboard(id: string): Promise<void> {
        await this.http.orchestrateRequest({
            method: 'DELETE',
            url: `/techline/dashboard/${id}`,
        });
    }
}
